import React, { useState } from 'react';
import {
  Box,
  Stack,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import MyTableBoldCell from '../../../components/material-ui/adaptive/MyTableBoldCell';
import ConfirmDialog from '../../../components/shared/ConfirmDialog';
import ShowContainer from '../../../components/material-ui/ShowContainer';
import CusLink from '../../../components/material-ui/CusLink';
import InfoDialog from '../../../components/shared/InfoDialog';
import ErrorBoundary from '../../../components/material-ui/error_boundary/ErrorBoundary';
import LanguageSelect from '../../../components/shared/LanguageSelect';
import ListBannersTableRow from './ListBannersTableRow';
import BannerTableShowFile from './BannerTableShowFile';
import { stickyCellRight } from '../../../components/bonus/ui/styles';

export default function ListBannersTable({ banners, onBannerDelete, filterLang, setFilterLang }) {
  const { t } = useTranslation();
  const { groupId } = useParams();

  const [openDelete, setOpenDelete] = useState(undefined);
  const [selectBanner, setSelectBanner] = useState(undefined);

  const onClickDelete = () => {
    onBannerDelete(openDelete);
  };

  return (
    <>
      <TableContainer sx={{ maxHeight: 'calc(100svh - 325px)', overflow: 'auto' }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <MyTableBoldCell isLess>{t('Name')}</MyTableBoldCell>
              <MyTableBoldCell isLess>{t('Pos.')}</MyTableBoldCell>
              <MyTableBoldCell isLess>
                <Stack gap={1}>
                  <Typography pl={1.5}>{t('Lang')}</Typography>
                  <LanguageSelect
                    isAllLanguages
                    value={filterLang}
                    setValue={setFilterLang}
                    label={''}
                    isVerySmall
                    isRow
                  />
                </Stack>
              </MyTableBoldCell>
              <MyTableBoldCell isLess>{t('Link')}</MyTableBoldCell>
              <MyTableBoldCell isLess>{t('Banner text')}</MyTableBoldCell>
              <MyTableBoldCell isLess>{t('Banner')}</MyTableBoldCell>
              <MyTableBoldCell isLess> {t('Mobile banner')}</MyTableBoldCell>
              <MyTableBoldCell isLess>{t('Activity date')}</MyTableBoldCell>
              <MyTableBoldCell sx={{ ...stickyCellRight, zIndex: 2 }}>
                {t('Actions')}
              </MyTableBoldCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {banners.map((banner) => (
              <ListBannersTableRow
                key={banner.id}
                banner={banner}
                setSelectBanner={setSelectBanner}
                setOpenDelete={setOpenDelete}
                groupId={groupId}
                stickyCell={stickyCellRight}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <ShowContainer condition={!banners.length}>
        <Stack p={2} display={'flex'} direction={'row'} alignItems={'center'} gap={1}>
          <Typography variant="body1">{t('There are no banners in this group yet.')}</Typography>
          <Typography variant="body2">{t('Try changing filters')}</Typography>

          <CusLink text="Add banner" to={`/slider-banners/${groupId}/new`} />
        </Stack>
      </ShowContainer>
      <ConfirmDialog
        open={openDelete}
        title={t('Confirm deletion')}
        content={t('Are you sure you want to delete this item? This action cannot be undone.')}
        onClose={() => setOpenDelete(false)}
        onConfirm={onClickDelete}
      />

      <InfoDialog open={selectBanner} onClose={() => setSelectBanner(false)}>
        <ErrorBoundary>
          <Box width={'100%'}>
            <BannerTableShowFile autoPlay fileUrl={selectBanner} maxHeight="400px" />
          </Box>
        </ErrorBoundary>
      </InfoDialog>
    </>
  );
}
